
















import Vue from 'vue';
import CustomType from '../../types/vue';

export interface ComponentApp extends Vue {
    value: string | Number
    isRequired: Boolean
    action: (result: string|Number, Sucess: Boolean) => any
    success: Boolean  
    placeholder: string 
    isDisabled: Boolean
    capitalize: (str: string) => string
    translateMessage: (str: string, istrad: boolean) => string
    name: string
    data: Array<{ key: number, value: string}>
    isTrad: Boolean
}

var component: Vue.ComponentOptions<ComponentApp> = {
    name: 'Selecteur',
    props: {
        data: { type: Array, required: true },
        placeholder: { type: String, required: false },
        value: { required: true },
        action: { type: Function, required: true },
        isRequired: { type: Boolean, required: false, default: false },
        isDisabled: { type: Boolean, required: false, default: false },
        isTrad: { type: Boolean, required: false, default: false },
    },
    computed: {
        success: function () {
            if (this.isRequired)
                return this.value != ""
            else
                return true;
        },
        locale: function(){
            return this.$language;
        }
    },
    watch: {
        value: function (val) {
            $('[name = "' + this.name + '"]').val(val).trigger('change');
        },
        locale: function(val){
            $('[name = "' + this.name + '"]').select2('destroy');
            
            var vm = this;
            $('[name = "'+this.name+'"]')
            .select2({
                placeholder: vm.translateMessage(vm.placeholder, true),
                allowClear: true
            })
            .trigger('change')
            .on('change', function (event) {
                if(this.selectedOptions.length > 0){
                    vm.action(this.selectedOptions[0].value, vm.success)
                }
            });
        }
    },
    data: function () {
        return {
            name: "select" + new Date().getMilliseconds(),
        }
    },
    filters: {
        capitalize (str) {
            return str.charAt(0).toUpperCase() + str.slice(1)
        }
    },
    methods: {
        translateMessage: function (cle, isTrad = this.isTrad) {
            if (Number.isInteger(parseInt(cle)))
                return cle

            if (cle === "" || cle === undefined || cle === null)
                return "";

            if(isTrad)
                return this.translate(this.$language, cle);
            else
                return cle;
        },
        isSelected: function (val) {
            return (val === this.value) ? 'selected' : '';
        }
    },
    mounted: function () {
        var vm = this;
        $('[name = "'+this.name+'"]')
        .select2({
            placeholder: vm.translateMessage(vm.placeholder, true),
            allowClear: true
        })
        .trigger('change')
        .on('change', function (event) {
            if(this.selectedOptions.length > 0){
                vm.action(this.selectedOptions[0].value, vm.success)
            }
        });
    },
    destroyed: function () {
        $('[name = "' + this.name + '"]').off().select2('destroy')
    }
}
export default component;



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/form/Select.vue